import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;

var ifNotAuth = function ifNotAuth(to, from, next) {
  if (!LocalStorage.getItem("loggedIn")) {
    next();
  } else {
    next("/");
  }
};

var ifAuth = function ifAuth(to, from, next) {
  if (LocalStorage.getItem("loggedIn")) {
    next();
  } else {
    next("/auth");
  }
};

export default function buildRoutes(store) {
  var hasGroup = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
      var group, selectedGroupId, selectedOrganizationId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              group = store.getters["Group/group"];
              selectedGroupId = LocalStorage.getItem("selectedGroupId");
              selectedOrganizationId = LocalStorage.getItem("selectedOrganizationId"); // Als er een groep in de store is, doorlaten

              if (!group) {
                _context.next = 6;
                break;
              }

              next();
              return _context.abrupt("return");

            case 6:
              if (!selectedGroupId) {
                _context.next = 21;
                break;
              }

              _context.prev = 7;
              _context.next = 10;
              return store.dispatch("Group/fetchGroup", selectedGroupId);

            case 10:
              if (!store.getters["Group/group"]) {
                _context.next = 16;
                break;
              }

              if (!(!store.getters["Organization/organization"] && selectedOrganizationId)) {
                _context.next = 14;
                break;
              }

              _context.next = 14;
              return store.dispatch("Organization/fetchOrganization", selectedOrganizationId);

            case 14:
              next();
              return _context.abrupt("return");

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](7);
              console.error("Error restoring group:", _context.t0);

            case 21:
              // Geen groep geselecteerd of laden mislukt, doorsturen naar home
              next("/");

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 18]]);
    }));

    return function hasGroup(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  var hasUser = function hasUser(to, from, next) {
    if (store.getters["User/user"]) {
      next();
    } else {
      next("/");
    }
  };

  var routes = [{
    path: "/auth",
    component: function component() {
      return import("layouts/StartLayout");
    },
    beforeEnter: ifNotAuth,
    children: [{
      path: "",
      component: function component() {
        return import("pages/auth/PageLoginRegister");
      },
      name: "login"
    }, {
      path: "/login/:driver/callback",
      component: function component() {
        return import("pages/loaders/PageLoginDriversLoader");
      },
      name: "page.login.drivers"
    }, {
      path: "/password/reset-email",
      component: function component() {
        return import("pages/auth/PasswordEmail");
      },
      name: "password-reset-email"
    }, {
      path: "/password/reset/:token",
      component: function component() {
        return import("pages/auth/PasswordReset");
      },
      name: "password-reset"
    }, {
      path: "/password/set/:token",
      component: function component() {
        return import("pages/auth/PasswordReset");
      },
      name: "password-set"
    }]
  }, {
    path: "/",
    component: function component() {
      return import("layouts/MainLayout");
    },
    beforeEnter: ifAuth,
    children: [{
      path: "",
      component: function component() {
        return import("pages/PageOrganizations");
      },
      name: "organizations"
    }, {
      path: "/organizations/:organizationId",
      component: function component() {
        return import("pages/organization/PageSettings");
      },
      name: "organization"
    }, {
      path: "/organizations/:organizationId/users",
      component: function component() {
        return import("pages/organization/PageUsers");
      },
      name: "organization-users"
    }, {
      path: "/meetings",
      component: function component() {
        return import("pages/PageMeetings");
      },
      name: "meetings",
      beforeEnter: hasGroup
    }, {
      path: "/meetings/:meetingId",
      component: function component() {
        return import("pages/PageMeeting");
      },
      name: "meeting",
      beforeEnter: hasGroup
    }, {
      path: "/meetings/meeting",
      redirect: "/meetings"
    }, {
      path: "/actionlist",
      component: function component() {
        return import("pages/PageActions");
      },
      name: "actionlist",
      beforeEnter: hasGroup
    }, {
      path: "/decisions",
      component: function component() {
        return import("pages/PageDecisions");
      },
      name: "decisions",
      beforeEnter: hasGroup
    }, {
      path: "/attachments",
      component: function component() {
        return import("pages/PageAttachments");
      },
      name: "attachments",
      beforeEnter: hasGroup
    }, {
      path: "/members",
      component: function component() {
        return import("pages/PageMembers");
      },
      name: "members",
      beforeEnter: hasGroup
    }, {
      path: "/settings",
      component: function component() {
        return import("pages/PageSettings");
      },
      name: "settings",
      beforeEnter: hasGroup
    }, {
      path: "/my-actions",
      component: function component() {
        return import("pages/PageMyActions");
      },
      name: "my_actions",
      beforeEnter: hasUser
    }, {
      path: "/profile",
      component: function component() {
        return import("pages/PageProfile");
      },
      name: "profile",
      beforeEnter: hasUser
    }]
  }, {
    path: "/errors/500",
    component: function component() {
      return import("src/pages/errors/Error500.vue");
    },
    name: "error500"
  }]; // Always leave this as last one

  if (process.env.MODE !== "ssr") {
    routes.push({
      path: "*",
      component: function component() {
        return import("src/pages/errors/Error404.vue");
      }
    });
  }

  return routes;
}